<template>
<div class="lp-pagination-top">
  <div class="lp-pagination-options">
    <span class="pagination-options-label">{{ $t('Items per page') }}:</span>
    <sui-dropdown
      :placeholder="$t('Items per page')"
      selection
      :options="limitOptions"
      v-model="limit"
    />
  </div>
  <div is="uib-pagination" :max-size="maxPages" :boundary-links="true" class="lp-pagination" v-model="pagination" :total-items="totalItems" :items-per-page="limit" @change="updatePagination" previous-text="‹" next-text="›" first-text="«" last-text="»"></div>
</div>
</template>

<script>
import {mapState, mapMutations} from 'vuex';

export default {
  name: 'pagination',
  data() {
    return {
      limitOptions: [
        {text: '10', value: 10},
        {text: '15', value: 15},
        {text: '20', value: 20},
        {text: '50', value: 50},
        {text: '100', value: 100}
      ],
      offset: 0,
      limit: 10,
      totalItems: null,
      maxPages: 5,
      pagination: {
        currentPage: 1
      }
    };
  },
  props: {
    paginationSettingsKey: {
      type: String,
      default: 'default'
    },
  },
  computed: {
    ...mapState([
      'paginationSettings'
    ])
  },
  mounted: function () {
    if (this.paginationSettings && this.paginationSettings[this.paginationSettingsKey]) {
      this.limit = this.paginationSettings[this.paginationSettingsKey];
    } else {
      this.limit = 10;
    }
  },
  methods: {
    ...mapMutations({
      setPaginationSettings: 'setPaginationSettings',
    }),
    updatePagination: function () {
      let offset = this.limit * (this.pagination.currentPage - 1);
      if (offset > this.totalItems) {
        this.pagination.currentPage = parseInt(Math.ceil(this.totalItems / this.limit));
      }
      this.offset = this.limit * (this.pagination.currentPage - 1);

      // Preserve pagination settings between page reloads
      this.setPaginationSettings({key: this.paginationSettingsKey, value: this.limit});

      this.$emit('paginationUpdated');
    }
  },
  watch: {
    limit: function () {
      this.updatePagination();
    },
    pagination: function (value) {
      // Reset to first page if there ever is a page not set
      if (!value.currentPage) {
        this.pagination.currentPage = 1;
        this.updatePagination();
      }
    }
  },
};
</script>

<style scoped>

</style>
